import { useState } from "react";
import {
  CreditCardIcon,
  JetsPickupIcon,
  UtensilsIcon,
  BoltIcon,
  CalendarIcon,
  TimeForwardIcon,
  JetsDeliveryIcon,
} from "~/icons";
import { Box } from "../Box/Box";
import { Text } from "../Text/Text";
import { InlineFieldButton } from "../InlineFieldButton/InlineFieldButton";
import { Stack } from "../Stack/Stack";
import Skeleton from "react-loading-skeleton";

type IconName =
  | "delivery"
  | "pick-up"
  | "credit-card"
  | "utensils"
  | "bolt"
  | "time-forward"
  | "calendar";

export function OptionButton(props: {
  onPress: () => void;
  title?: string;
  subTitle?: string | JSX.Element;
  icon: IconName;
  direction?: "right" | "down";
  disabled?: boolean;
  loading?: boolean;
  iconColor?: string;
}) {
  const [pressed, setPressed] = useState<boolean>(false);

  const handlePress = () => {
    if (props.disabled) return;
    setPressed(true);
    props.onPress();
  };

  let iconSkeletonSize = 24;

  if (["delivery", "pick-up"].includes(props.icon)) {
    iconSkeletonSize = 64;
  }

  return (
    <InlineFieldButton
      onPress={handlePress}
      pressed={pressed}
      padding={"3"}
      direction={props.direction}
      noIcon={props.loading}
    >
      <Box
        display={"flex"}
        flexDirection={"row"}
        width="full"
        alignItems={"center"}
      >
        <Box
          alignItems={"center"}
          justifyContent={"center"}
          display={"flex"}
          height="full"
          paddingRight={"3"}
        >
          {props.loading ? (
            <Skeleton width={iconSkeletonSize} height={iconSkeletonSize} />
          ) : (
            <OptionButtonIcon
              icon={props.icon}
              disabled={props.disabled}
              color={props.iconColor}
            />
          )}
        </Box>
        <Box overflow={"hidden"} paddingRight="3">
          <Stack space={"1"}>
            <Text
              align={"left"}
              size="large"
              font="special"
              color="jets-black"
              weight="semi-strong"
              truncate={true}
              transform="uppercase"
            >
              {props.loading ? <Skeleton width={80} /> : props.title}
            </Text>
            <Text size="standard" color="neutral-500">
              {props.loading ? <Skeleton width={140} /> : props.subTitle}
            </Text>
          </Stack>
        </Box>
      </Box>
    </InlineFieldButton>
  );
}

function OptionButtonIcon(props: {
  icon?: IconName;
  disabled?: boolean;
  color?: string;
}) {
  const color = props.disabled
    ? "var(--color-neutral-400)"
    : props.color || "var(--color-primary)";

  switch (props.icon) {
    case "delivery":
      return <JetsDeliveryIcon />;
    case "credit-card":
      return <CreditCardIcon color={color} />;

    case "pick-up":
      return <JetsPickupIcon />;
    case "utensils":
      return <UtensilsIcon color={color} />;
    case "bolt":
      return <BoltIcon color={color} />;
    case "calendar":
      return <CalendarIcon color={color} />;
    case "time-forward":
      return <TimeForwardIcon color={color} />;
    default:
      return <></>;
  }
}
